import { Box, Text, Button, IconButton } from "@chakra-ui/react";

import { useSelector } from "react-redux";
import { IconChevronRight, IconChevronLeft } from "../../../styles/icons";
import { pmsSteps } from "../../utilities/uiConfigData";

const FooterPmsSearch = ({ handleClickNext, handleClickPrev }) => {
  const state = useSelector((state) => state);
  const pmsStep = state.layout.pmsSearchStep;

  const footerStyle = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "white",
    //height: '40px',
    width: "100%",
    py: "1.5rem",
  };

  const footerButtonStyle = {
    width: "100%",
    maxW: "container.sm",
    flex: 1,
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
    alignItems: "center",
    mx: { base: "24px", lg: "0" },
  };

  const renderProgressBarLabels = () => {
    return (
      <Box
        display={{ base: "flex", lg: "none" }}
        flexDirection="column"
        alignItems="center"
      >
        <Text textStyle="h7" color="brand.200">
          {pmsStep + 1} of {pmsSteps.length}
        </Text>
        <Text textStyle="h7" color="brand.400">
          {pmsSteps[pmsStep].label}
        </Text>
      </Box>
    );
  };

  return (
    <Box sx={footerStyle} display={{ base: "flex", lg: "none" }}>
      <Box sx={footerButtonStyle}>
        {/* desktop */}
        <Button
          display={{ base: "none", lg: "none" }}
          variant="gradient"
          fromcolor="primary.600"
          tocolor="primary.500"
          onClick={() => handleClickPrev()}
        >
          <Box as="span">Previous</Box>
        </Button>
        <Button
          display={{ base: "none", lg: "none" }}
          onClick={() => {
            if (Number(pmsStep) < pmsSteps.length - 1) handleClickNext();
          }}
        >
          Next step
        </Button>
        {/* mobile */}
        <IconButton
          display={{ base: "flex", lg: "none" }}
          variant="outline"
          aria-label="search menu"
          icon={<IconChevronLeft />}
          onClick={() => handleClickPrev()}
        />
        {renderProgressBarLabels()}
        <IconButton
          display={{ base: "flex", lg: "none" }}
          aria-label="search menu"
          icon={<IconChevronRight />}
          onClick={() => {
            if (Number(pmsStep) < pmsSteps.length - 1) handleClickNext();
          }}
        />
      </Box>
    </Box>
  );
};

export default FooterPmsSearch;
